export default __webpack_public_path__ + "static/media/icon_privacy_overview_step1.40645208.svg";